export const LOGO_PATH = '/logo-larrysport.png';
export const LOGO_DARK_PATH = '/logo-larrysport-blue.png';

export const APP_VERSION = '0.1.0';

export const genkey = () => {
  let caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let longitud = 12;
  let resultado = '';
  for (let i = 0; i < longitud; i++) {
    resultado += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
  }
  return resultado;
};
